import { useState } from 'react'
import { DataType } from '../types/advanced-grid.types'

/**
 * Hook to allow the grid handle the selected records
 * @author Alejandro Quiroz <alejandro.devop@gmail.com>
 * @version 1.0.0
 * @param data The Api received data
 * @returns
 */
const useSelectedRecords = (data: DataType[]) => {
    const [selectedRecords, setSelectedRecords] = useState<(number | string)[]>([])
    const [selectAllCheck, setSelectAll] = useState<boolean>(false)
    const pageIds = data.map((item) => parseInt(item.id.toString(), 10))
    const handleSelectRecord = (record: number | string) => {
        setSelectAll(false)
        if (selectedRecords.includes(record)) {
            setSelectedRecords(
                selectedRecords.filter(
                    (item) => parseInt(item.toString(), 10) !== parseInt(record.toString(), 10)
                )
            )
        } else {
            setSelectedRecords([...selectedRecords, record])
        }
    }

    const handleSelectAll = () => {
        const newValue = !selectAllCheck
        setSelectAll(newValue)
        if (newValue === true && Array.isArray(data)) {
            setSelectedRecords([
                ...selectedRecords,
                ...pageIds.filter((id) => !selectedRecords.includes(id))
            ])
        } else {
            setSelectedRecords(
                selectedRecords.filter((id) => !pageIds.includes(parseInt(id.toString(), 10)))
            )
        }
    }

    const resetCheckAll = () => setSelectAll(false)

    const clearSelection = () => setSelectedRecords([])

    return {
        clearSelection,
        selectedRecords,
        selectAllCheck,
        handleSelectAll,
        handleSelectRecord,
        resetCheckAll
    }
}

export default useSelectedRecords
